import { Select } from 'antd';
import { useSearchParams } from 'react-router-dom';

import useFilters from '../../hooks/useFilters';

import './filters.scss';

interface Props {
  showFilters: string[];
  onDropdownToggle?: (isOpen: boolean) => void;
}

const Filters = ({ showFilters = [], onDropdownToggle }: Props) => {
  let [searchParams, setSearchParams] = useSearchParams();
  const { filters } = useFilters(showFilters);

  const onSelectFilter = (filterName: string, value: string) => {
    const newSearchParams = new URLSearchParams(searchParams);

    if (!value) {
      clearSearchParam(filterName);
      return;
    }

    newSearchParams.set(filterName, value);
    setSearchParams(newSearchParams);
  };

  const clearSearchParam = (param: string) => {
    searchParams.delete(param);
    setSearchParams(searchParams);
  };

  return (
    <div
      id="filters-group"
      className="flex items-center min-w-[260px] min-h-[60px]"
    >
      {filters?.map((filterGroup: any) => {
        const options = [...(filterGroup.children || [])];
        return (
          <Select
            key={filterGroup.name}
            showSearch
            style={{
              width: 260,
              marginRight: 15,
              paddingTop: 12,
              paddingBottom: 12,
              zIndex: 1001,
              minWidth: 260,
            }}
            placeholder={`Select ${filterGroup.label.split(' ')[0]}`}
            filterOption={(input: string, option: any) =>
              (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
            }
            filterSort={(optionA, optionB) =>
              (optionA?.label ?? '')
                .toLowerCase()
                .localeCompare((optionB?.label ?? '').toLowerCase())
            }
            options={options}
            onChange={(value) => onSelectFilter(filterGroup.name, value)}
            allowClear
            value={searchParams.get(filterGroup.name)}
            maxTagCount="responsive"
            onDropdownVisibleChange={onDropdownToggle}
            loading={filterGroup.loading}
          />
        );
      })}
    </div>
  );
};

export default Filters;
